module.exports = __webpack_public_path__ + "static/media/ruby_on_rails.a017067f.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/Portfolio/images/platforms/ruby_on_rails.png
 ** module id = 232
 ** module chunks = 0
 **/